import React from 'react';
import { Link } from 'react-router-dom';

export default function FooterSection() {
  const quickLinks = [
    { name: 'Beranda', href: '#hero' },
    { name: 'Menu', href: '#menu' },
    { name: 'Tentang Kami', href: '#about' },
    { name: 'Reservasi', href: '#reservation' },
    { name: 'Galeri', href: '#gallery' },
    { name: 'Kontak', href: '#contact' }
  ];

  const menuCategories = [
    { name: 'Ramen Premium', price: 'Mulai Rp 65.000' },
    { name: 'Sushi & Sashimi', price: 'Mulai Rp 85.000' },
    { name: 'Tempura Set', price: 'Mulai Rp 45.000' },
    { name: 'Minuman Jepang', price: 'Mulai Rp 15.000' }
  ];

  const services = [
    { name: 'Dine In', icon: 'ri-restaurant-line' },
    { name: 'Take Away', icon: 'ri-takeaway-line' },
    { name: 'Delivery', icon: 'ri-truck-line' },
    { name: 'Catering', icon: 'ri-service-line' },
    { name: 'Private Event', icon: 'ri-calendar-event-line' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-black to-gray-900 border-t border-red-500/20">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-red-600 to-yellow-500 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white font-black text-xl" style={{ fontFamily: '"Noto Sans JP", serif' }}>竹</span>
              </div>
              <div>
                <h3 className="text-2xl font-black text-white" style={{ fontFamily: '"Noto Sans JP", serif' }}>
                  TAKEYA
                  <span className="text-yellow-400 ml-2 text-lg">(竹や)</span>
                </h3>
                <p className="text-xs text-gray-400 font-medium" style={{ fontFamily: '"Orbitron", sans-serif' }}>
                  AUTHENTIC JAPANESE
                </p>
              </div>
            </div>
            
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Restoran Jepang futuristik pertama di Bukittinggi yang menghadirkan cita rasa autentik dengan pengalaman dining modern yang tak terlupakan.
            </p>

            <div className="space-y-3 text-gray-300 text-sm">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-red-400 w-4 h-4 flex items-center justify-center"></i>
                <span>Jl. Raya Bukittinggi - Payakumbuh No.km 6</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-green-400 w-4 h-4 flex items-center justify-center"></i>
                <span>+62 812 754 3743</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-blue-400 w-4 h-4 flex items-center justify-center"></i>
                <span>info@takeya-restaurant.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold text-white mb-6">Navigasi Cepat</h4>
            <div className="space-y-3">
              {quickLinks.map((link, index) => (
                <button
                  key={index}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-gray-300 hover:text-red-400 transition-colors duration-300 cursor-pointer text-left"
                >
                  {link.name}
                </button>
              ))}
              <Link to="/customer" className="block text-gray-300 hover:text-red-400 transition-colors duration-300">
                Pesan Online
              </Link>
              <Link to="/admin" className="block text-gray-300 hover:text-red-400 transition-colors duration-300">
                Panel Admin
              </Link>
            </div>
          </div>

          {/* Menu Highlights */}
          <div>
            <h4 className="text-xl font-bold text-white mb-6">Menu Unggulan</h4>
            <div className="space-y-4">
              {menuCategories.map((menu, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div>
                    <h5 className="text-gray-300 font-medium">{menu.name}</h5>
                    <p className="text-yellow-400 text-sm font-semibold">{menu.price}</p>
                  </div>
                </div>
              ))}
            </div>
            <button
              onClick={() => scrollToSection('#menu')}
              className="mt-6 text-red-400 hover:text-red-300 font-semibold text-sm transition-colors cursor-pointer"
            >
              Lihat Menu Lengkap →
            </button>
          </div>

          {/* Services & Contact */}
          <div>
            <h4 className="text-xl font-bold text-white mb-6">Layanan Kami</h4>
            <div className="grid grid-cols-1 gap-3 mb-8">
              {services.map((service, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <i className={`${service.icon} text-yellow-400 w-4 h-4 flex items-center justify-center`}></i>
                  <span className="text-gray-300 text-sm">{service.name}</span>
                </div>
              ))}
            </div>

            {/* Social Media */}
            <h5 className="text-lg font-bold text-white mb-4">Ikuti Kami</h5>
            <div className="flex space-x-4">
              <button
                onClick={() => window.open('https://instagram.com/takeya_restaurant', '_blank')}
                className="w-10 h-10 bg-gradient-to-br from-pink-500 to-red-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-white w-5 h-5 flex items-center justify-center"></i>
              </button>
              <button
                onClick={() => window.open('https://facebook.com/takeya.restaurant', '_blank')}
                className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              >
                <i className="ri-facebook-line text-white w-5 h-5 flex items-center justify-center"></i>
              </button>
              <button
                onClick={() => window.open('https://tiktok.com/@takeya_restaurant', '_blank')}
                className="w-10 h-10 bg-gradient-to-br from-gray-800 to-gray-900 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              >
                <i className="ri-tiktok-line text-white w-5 h-5 flex items-center justify-center"></i>
              </button>
              <button
                onClick={() => window.open('https://wa.me/628127543743', '_blank')}
                className="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white w-5 h-5 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-black/50">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm text-center md:text-left">
              <p>© 2024 TAKEYA Restaurant (竹や). All rights reserved.</p>
              <p className="mt-1">Rasa Autentik Asli Jepang Satu-Satunya di Bukittinggi</p>
            </div>
            
            <div className="flex items-center space-x-6">
              <button
                onClick={() => window.open('https://wa.me/628127543743?text=Halo TAKEYA! Saya ingin melakukan reservasi.', '_blank')}
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 py-2 rounded-full font-semibold text-sm transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2 w-4 h-4 flex items-center justify-center inline-flex"></i>
                Reservasi Sekarang
              </button>
              
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-yellow-400 text-sm transition-colors duration-300"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Back to Top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-24 left-6 w-12 h-12 bg-gradient-to-br from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-300 z-40 cursor-pointer"
      >
        <i className="ri-arrow-up-line w-6 h-6 flex items-center justify-center"></i>
      </button>
    </footer>
  );
}